import { useState } from 'react'

import { FinancialAccount } from '@/reducers/finances/financialAccountsReducer'
import { useAnalyticsTrack } from '@/features/amplitude'
import { Accordion, Button, List, Tooltip } from '@/ui'
import { AccountBannerProps } from '../AccountBannerCard'
import { ShowAccountDialog } from '../ShowAccountDialog'

interface HiddenAccountsAccordionProps {
  hiddenAccounts: FinancialAccount[]
  institutionName: string
  setAccountBanner: (accountBanner: AccountBannerProps | null) => void
  disconnectedOn: string | null
  initialOpen: string
}

export const HiddenAccountsAccordion = ({
  hiddenAccounts,
  institutionName,
  setAccountBanner,
  disconnectedOn,
  initialOpen,
}: HiddenAccountsAccordionProps) => {
  const track = useAnalyticsTrack()
  const [showDialogOpen, setShowDialogOpen] = useState(false)
  const [accountToShow, setAccountToShow] = useState<FinancialAccount | null>(
    null
  )

  const handleDialog = (account: FinancialAccount) => {
    setAccountToShow(account)
    setShowDialogOpen(true)
    track('clicked review bank account button')
  }

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Accordion defaultValue={initialOpen} variant="text" type="single">
          <Accordion.Trigger>Hidden accounts</Accordion.Trigger>

          <Accordion.Content>
            <List>
              {hiddenAccounts.map((account) => {
                return (
                  <Accordion.Item key={account.id} value={account.name}>
                    {account.name} {account.mask}{' '}
                    <Button
                      disabled={Boolean(disconnectedOn)}
                      onClick={() => handleDialog(account)}
                      size="sm"
                      variant="link"
                    >
                      Show
                    </Button>
                  </Accordion.Item>
                )
              })}

              {accountToShow && (
                <ShowAccountDialog
                  open={showDialogOpen}
                  account={accountToShow}
                  setAccountBanner={setAccountBanner}
                  onClose={() => {
                    setShowDialogOpen(false)
                    setAccountToShow(null)
                  }}
                />
              )}
            </List>
          </Accordion.Content>
        </Accordion>
      </Tooltip.Trigger>

      <Tooltip.Content>
        Connections to these accounts will still appear on the {institutionName}{' '}
        website, but all transactions will be hidden on Heard.
      </Tooltip.Content>
    </Tooltip>
  )
}
